import { processResponse, processError } from './auth';

export const getCache = (key) => {
  const url = `${process.env.GATSBY_BASE_URL}public/cache?key=${encodeURIComponent(key)}`;

  return fetch(url, {})
    .then((response) => {
      return processResponse(response);
    })
    .then((response) => {
      return { ...response };
    })
    .catch((err) => {
      processError(err, 'getCache');
    });
};
